export const SCORECARD_TYPES = {
  regular: 'regular',
  audit: 'audit',
};

export const SCORECARD_TABS_LABELS = {
  QA_REVIEW: 'QA Review',
  AUDIT: 'Audit',
};

export const SCORECARD_TYPES_OPTIONS = [
  {
    label: 'QA Review Scorecard',
    value: SCORECARD_TYPES.regular,
  },
  {
    label: 'Audit Scorecard',
    value: SCORECARD_TYPES.audit,
  },
];

// Mirrors QaFormSection::OBJECTIVE_MAX_LENGTH so the field stops accepting input at
// the same point the server stops accepting it.
export const SECTION_OBJECTIVE_MAX_LENGTH = 1000;

export const QA_REVIEW_ORIGIN = {
  stream: 'stream',
  initial: 'initial',
  assignment: 'assignment',
};

export enum AssignmentCadence {
  CUSTOM = 'custom',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}

export const INTERACTION_ID_DISABLED_HELPTEXT =
  'Want to review a different interaction in this Assignment? Select Skip Interaction to receive another interaction that meets the Assignment criteria.';
